// 日時の表示整形。既存共通ユーティリティが無いため本 feature 内に閉じて持つ。
// サーバーは JST で日時を返すため、端末のタイムゾーン設定で表示がずれないよう Asia/Tokyo 固定で整形する。
const JST_FORMATTER = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23"
});

export const formatDateTime = (value: string | null): string => {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const parts = Object.fromEntries(JST_FORMATTER.formatToParts(date).map((part) => [part.type, part.value]));

  return `${parts.year}/${parts.month}/${parts.day} ${parts.hour}:${parts.minute}`;
};
